import  React, { Component }from 'react';
import { Form, Select, Input, Button, Row, Col, DatePicker } from 'antd';
import { getConfigList } from '../../apis/api'
const { Option } = Select;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
class SearchForm extends Component {
  constructor (props) {
    super(props)
    this.state={
      systemList: [],
      sourceList: ['GET','POST','PUT','DELETE','PATCH','OPTIONS','HEAD','TRACE','CONNECT','COPY','LINK','UNLINK','PURGE']
    }
  }

  componentDidMount() {
    this.getConfigList()
  }

  // 获取应用系统列表
  getConfigList = () => {
    const { setFieldsValue } = this.props.form;
    getConfigList({ access_token: sessionStorage.getItem('access_token') }).then(res => {
      if(res.code === 0) {
        this.setState({
          systemList: res.content || [],
        },() => {
          if(this.state.systemList && this.state.systemList.length != 0){
            setFieldsValue({
              model: this.state.systemList[0].model + '=' + this.state.systemList[0].name
            })
          }
          this.props.doSearch()
        })
      } else {
        this.setState({
          systemList: [],
        })
      }
    })
  }

  render() { 
    const { getFieldDecorator } = this.props.form;
    const { sourceList, systemList } = this.state;
    
    const formItemLayout = {
      labelCol: {
        md:{ span: 6 },
        xs:{ span: 8 }
      },
      wrapperCol: {
        md:{ span: 18 },
        xs:{ span: 16 }
      },
    };
    return (
      <Form
        name="advanced_search"
        className="ant-advanced-search-form"
        {...formItemLayout}
      >
        <Row gutter={24} style={{marginRight: 0}}>
          <Col xs={24} md={12} lg={12} xl={8} span={8}>
            <FormItem 
              label="应用系统" 
              className="form-item"
            >
            {getFieldDecorator('model')(
              <Select placeholder="请选择" style={{width: 224}}>
                {systemList.map((item,index) => (
                  <Option value={`${item.model}=${item.name}`} key={index}>{item.name}</Option>
                ))}
              </Select>
            )}
            </FormItem>   
          </Col>
          <Col xs={24} md={12} lg={12} xl={8} span={8}>
           <FormItem 
              label="uuid" 
              className="form-item"
            >
            {getFieldDecorator('uuid', {
              initialValue: ''
            })(
              <Input
                type="text"
                placeholder="请输入uuid"
                style={{width: 224}}
              />
            )}
            </FormItem>  
          </Col>
          <Col xs={24} md={12} lg={12} xl={8} span={8}>
           <FormItem 
              label="oa账号" 
              className="form-item"
            >
            {getFieldDecorator('oa', {
              initialValue: ''
            })(
              <Input
                type="text"
                placeholder="请输入oa账号"
                style={{width: 224}}
              />
            )}
            </FormItem>  
          </Col>
          <Col xs={24} md={12} lg={12} xl={8} span={8}>
            <FormItem 
              label="请求方式" 
              className="form-item"
            >
            {getFieldDecorator('method')(
              <Select allowClear placeholder="请选择" style={{width: 224}}>
                {sourceList.map((item,index) => (
                  <Option value={item} key={index}>{item}</Option>
                ))}
              </Select>
            )}
            </FormItem>   
          </Col>
          <Col xs={24} md={12} lg={12} xl={8} span={8}>
           <FormItem 
              label="一级菜单" 
              className="form-item"
            >
            {getFieldDecorator('route')(
              <Input
                type="text"
                placeholder="请输入请求接口"
                style={{width: 224}}
              />
            )}
            </FormItem>  
          </Col>

          <Col xs={24} md={12} lg={12} xl={8} span={8} >
            <FormItem label="时间" >
            {getFieldDecorator('date')(
              <RangePicker 
                format="YYYY-MM-DD"
                placeholder={['开始日期','结束日期']}
                style={{width: 224}}
              />
            )}
            </FormItem>
          </Col>
          
          <Col span={8} style={{ float: 'right' }}>
            <FormItem label="button" className="search-btn" >
              <div style={{ width: 224 }}>
                <Button 
                  type="primary"  
                  onClick= { ()=>{
                    this.props.doSearch() }
                  }>
                  搜索
                </Button>
                <Button
                  style={{ margin: '0 8px' }}
                  onClick={() => {
                    this.props.reset();
                  }}
                >
                  重置
                </Button>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create({})(SearchForm)


// WEBPACK FOOTER //
// ./src/page/LogManagement/SearchForm.jsx